<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="700px"
    :title="$l('dialog_title_batch_update_customs') || '批量更新报关信息'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeCn') || '中国HSCODE'"
            prop="hscodeCn"
          >
            <el-input
              v-model="formData.hscodeCn"
              :placeholder="
                $l('INDEX.form_placeholder_hscodeCn') || '请输入中国HSCODE'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_originalPlace') || '境内货源地'"
            prop="originalPlace"
          >
            <el-input
              v-model="formData.originalPlace"
              :placeholder="
                $l('INDEX.form_placeholder_originalPlace') || '请输入境内货源地'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameCn') || '报关中文品名'"
            prop="hscodeName"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('INDEX.form_placeholder_hscodeNameCn') ||
                  '请输入报关中文品名'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameEn') || '报关英文品名'"
            prop="hscodeNameEn"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_hscodeNameEn') ||
                  '请输入报关英文品名'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_declarationElements') || '申报要素'"
            prop="declarationElements"
          >
            <el-input
              v-model="formData.declarationElements"
              :placeholder="
                $l('INDEX.form_placeholder_declarationElements') ||
                  '请输入申报要素'
              "
              clearable
              type="textarea"
              :rows="3"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">{{
        $l('INDEX.btn_cancel') || '取 消'
      }}</el-button>
      <el-button size="medium" type="primary" @click="save">{{
        $l('INDEX.btn_update') || '更新'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {},
      ctnGrossWeightKgRead: 0,
      ctnNetWeightKgRead: 0,
    }
  },
  computed: {
    rules() {
      return {
        hscodeName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        hscodeCn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        hscodeNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        declarationElements: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        originalPlace: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const params = {
        ...this.formData,
      }
      this.$emit('saveCustoms', params)
    },
  },
}
</script>
